/**
 * PhotoSwipe UMD Wrapper
 * 将ESM版本的PhotoSwipe包装并暴露到全局作用域
 */

(function() {
  'use strict';
  
  // 检查是否已经加载
  if (window.PhotoSwipe && window.PhotoSwipeLightbox) {
    console.log('PhotoSwipe already loaded globally');
    return;
  }

  // 动态加载PhotoSwipe模块
  async function loadPhotoSwipe() {
    try {
      
      // 动态导入PhotoSwipe模块
      const [PhotoSwipeLightboxModule, PhotoSwipeModule] = await Promise.all([
        import('./photoswipe-lightbox.esm.js'),
        import('./photoswipe.esm.js')
      ]);

      // 获取默认导出的类
      const PhotoSwipeLightbox = PhotoSwipeLightboxModule.default;
      const PhotoSwipe = PhotoSwipeModule.default;

      // 暴露到全局作用域
      window.PhotoSwipe = PhotoSwipe;
      window.PhotoSwipeLightbox = PhotoSwipeLightbox;
      
      
      // 触发加载完成事件
      window.dispatchEvent(new CustomEvent('photoswipe:loaded', {
        detail: { PhotoSwipe, PhotoSwipeLightbox }
      }));
      
    } catch (error) {
      
      // 触发加载失败事件
      window.dispatchEvent(new CustomEvent('photoswipe:error', {
        detail: { error: error.message }
      }));
    }
  }

  // 立即开始加载
  loadPhotoSwipe();
})();
